import axios from 'axios';
import { setBlockTracking } from 'vue';
import addresstypes from './addresstypes';
import moment from 'moment';
// initial state
// shape: [{ id, quantity }]
const state = () => ({
    list : [
    ],
    loaded : false,
    addNew : false,
})

  // getters
  const getters = {
    getConditions: (state) => (type) => {
        return state.list.filter(item => item.type == type);
    }
  }

  // actions
  const actions = {
  }

  // mutations
  const mutations = {
      clearBlocks(state){
          state.list = [];
      },
      init(state, data){
          state.list = data;
      },
      unshift(state, data){

        var index = state.list.findIndex(item => item.id == data.id);
        if(index > -1){
            state.list[index] = data;
        }else{
            state.list.unshift(data);
        }
      }
  }

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
  }
